import { render, staticRenderFns } from "./MasksPage.vue?vue&type=template&id=cd045094&scoped=true&"
import script from "./MasksPage.vue?vue&type=script&lang=js&"
export * from "./MasksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd045094",
  null
  
)

export default component.exports